import { isDefined, omit } from '@showroomjs/core';
import section from 'react-showroom-sections';
const COMPONENT_SECTIONS = section
    .map(function transformToComp(section) {
    if (section.type === 'group') {
        const items = section.items.map(transformToComp).filter(isDefined);
        if (items.length > 0) {
            return Object.assign(Object.assign({}, section), { items });
        }
    }
    else if (section.type === 'component') {
        return omit(section, ['data']);
    }
    return undefined;
})
    .filter(isDefined);
export const useComponentList = () => COMPONENT_SECTIONS;
//# sourceMappingURL=component-list-context.js.map